import { AutomationRuleDto } from './../interfaces/dto/automation-rule.dto';
import { Injectable } from "@angular/core";
import { EnvironmentService } from "../services/environment.service";
import { HttpClient } from "@angular/common/http";
import { AutomationFlowConfig } from "../interfaces/automation-flow-config.interface";
import { map, Observable } from "rxjs";
import { AutomationFlow } from "../enums/automation-flow.enum";
import { AutomationRule } from "../interfaces/automation-rule.interface";
import { AutomationRuleAdapter } from "../adapters/automation-rule.adapter";

@Injectable({
  providedIn: 'root'
})
export class AutomationService {
  constructor(
    private environmentService: EnvironmentService,
    private http: HttpClient,
    private ruleAdapter: AutomationRuleAdapter,
  ) { }

  getFlowConfigurations(): Observable<AutomationFlowConfig[]> {
    const url = this.environmentService.get('backendUrl') + `/automation/flow-configurations`;
    return this.http.get<AutomationFlowConfig[]>(url, {withCredentials: true}).pipe(
      map((response: AutomationFlowConfig[]) => {
        return response;
      })
    );
  }

  getRules(flow: AutomationFlowConfig, practiceId: string): Observable<AutomationRule[]> {
    const url = this.environmentService.get('backendUrl') + `/automation/flow/${flow.slug}/rules?practiceId=${practiceId}`;
    return this.http.get<AutomationRuleDto[]>(url, {withCredentials: true}).pipe(
      map((response: AutomationRuleDto[]) => {
        return response.map((r) => this.ruleAdapter.run(r));
      })
    );
  }

  saveRule(body: any, practiceId: string): Observable<AutomationRule> {
    let url = this.environmentService.get('backendUrl') + `/automation/rules`;

    if (body.id) {
      url += `/${body.id}?practiceId=${practiceId}`
    } else {
      url += `/?practiceId=${practiceId}`
    }

    return this.http.post<AutomationRuleDto>(url, {body: body}, {withCredentials: true}).pipe(
      map((res) => {
        return this.ruleAdapter.run(res);
      })
    );
  }

  setDryRunStatus(id: string, dryRun: boolean, practiceId: string): Observable<boolean> {
    const url = this.environmentService.get('backendUrl') + `/automation/rules/${id}/set-dry-run-status?practiceId=${practiceId}`;
    return this.http.patch<void>(url, {dryRun: dryRun}, {withCredentials: true}).pipe(
      map(() => {
        return true;
      })
    );
  }

  deleteRule(id: string, practiceId: string): Observable<boolean> {
    const url = this.environmentService.get('backendUrl') + `/automation/rules/${id}?practiceId=${practiceId}`;
    return this.http.delete<void>(url, {withCredentials: true}).pipe(
      map(() => {
        return true;
      })
    );
  }
}